module.exports = __webpack_public_path__ + "media/MorningLights.90ebb437.mp3";